import {
  Injectable, Provider, Type,
} from '@angular/core'
import { Subject } from 'rxjs'

export function provideVideoIntl(intl: Type<VideoIntl>): Provider {
  return {
    provide: VideoIntl,
    useClass: intl,
  }
}

@Injectable({ providedIn: 'root' })
export class VideoIntl {
  public readonly changes$ = new Subject<void>()

  public playButtonLabel = 'Play'

  public pauseButtonLabel = 'Pause'

  public muteButtonLabel = 'Mute'

  public unmuteButtonLabel = 'Unmute'

  public fullscreenButtonLabel = 'Fullscreen'

  public endFullscreenButtonLabel = 'End fullscreen'

  public videoTagUnsupported = 'Your browser does not support the video tag.'

  public seekSliderLabel = 'Seek slider'

  public seekSliderTimeCombinator = 'of'
}
